import NetworkPanel from 'components/network-panel'
import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from './header'

function Layout() {
  return (
    <>
      <Header />
      <NetworkPanel />
      <main>
        <Outlet />
      </main>
    </>
  )
}

export default Layout
